import React, { useState } from 'react';
import { Package, TrendingUp } from 'lucide-react';
import ChemicalManagement from './ChemicalManagement';
import StockMovements from './StockMovements';
import styles from './StockManagement.module.scss';

const StockManagement = () => {
  const [activeTab, setActiveTab] = useState('chemicals');

  const tabs = [
    {
      id: 'chemicals',
      label: 'Chemical Management',
      icon: Package,
      description: 'Manage chemical inventory, quantities, and thresholds'
    },
    {
      id: 'movements',
      label: 'Stock Movements',
      icon: TrendingUp,
      description: 'View stock movement history and changes'
    }
  ];

  return (
    <div className={styles.stockManagement}>
      <div className={styles.header}>
        <h1>Stock Management</h1>
        <p>Manage your chemical inventory and track stock movements</p>
      </div>

      <div className={styles.tabContainer}>
        <div className={styles.tabNavigation}>
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <Icon size={20} />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>

        <div className={styles.tabContent}>
          {activeTab === 'chemicals' && <ChemicalManagement />}
          {activeTab === 'movements' && <StockMovements />}
        </div>
      </div>
    </div>
  );
};

export default StockManagement;
